module.exports = __webpack_public_path__ + "static/media/logo10.47f107f2.png";